var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 12.2067C21 11.5949 20.9494 10.9798 20.8415 10.3779H12.1805V13.8437H17.1402C16.9344 14.9614 16.2731 15.9502 15.3048 16.5786V18.8273H18.2638C20.0013 17.2598 21 14.9449 21 12.2067Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1805 21C14.657 21 16.7455 20.203 18.2671 18.8273L15.3082 16.5786C14.4849 17.1275 13.4221 17.4384 12.1839 17.4384C9.7884 17.4384 7.75729 15.8543 7.02851 13.7246H3.9751V16.0428C5.53386 19.0819 8.70874 21 12.1805 21V21Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0251 13.7246C6.64047 12.6068 6.64047 11.3964 7.0251 10.2787V7.96045H3.97505C2.67271 10.5035 2.67271 13.4997 3.97505 16.0428L7.0251 13.7246V13.7246Z",
    fill: "#FBBC04"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1805 6.56176C13.4896 6.54191 14.7548 7.02474 15.7029 7.91101L18.3245 5.34147C16.6645 3.81364 14.4613 2.97366 12.1805 3.00012C8.70874 3.00012 5.53386 4.91818 3.9751 7.96062L7.02514 10.2788C7.75054 8.14581 9.78503 6.56176 12.1805 6.56176V6.56176Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.dcae0f403417184d8be0ba67c668ed23.svg";
export { ForwardRef as ReactComponent };